import { firebase, db } from '../firebase';
import { logs } from '../utils/constants-utils';

export default {
  // initial state
  state: {},
  effects: (dispatch) => ({
    async fetchByPropertyId({ propertyId, category }, rootState) {
      console.log({ category });
      const types = logs.categories[category];
      console.log({ types });
      const promiseList = types.map((t) =>
        db.child(`logs/${propertyId}`).orderByChild('type').equalTo(t).once('value')
      );
      let list = await Promise.allSettled(promiseList);
      console.log({ promiseResults: list });
      list = list.filter((r) => r.status === 'fulfilled').map((r) => r.value.val());
      list = list.reduce((prev, current) => [...prev, ...Object.values(current || [])], []);
      console.log({ list });
      dispatch.logs.genericReducer({ list });
    }
  }),
  reducers: {
    genericReducer(state, payload) {
      return {
        ...state,
        ...payload
      };
    }
  }
};
